import { render, staticRenderFns } from "./NotDriverMonthlyAdditional.vue?vue&type=template&id=57c2ddaa&"
import script from "./NotDriverMonthlyAdditional.vue?vue&type=script&lang=js&"
export * from "./NotDriverMonthlyAdditional.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports